<template>
  <UiField
    :label="label"
    :disabled="disabled"
    :loading="loading"
    :class="classAttr"
    v-bind="fieldProps"
  >
    <AutoSpinner>
      <BaseInput
        :type="type"
        :placeholder="placeholder"
        :value="value"
        :inputmode="inputmode"
        :min="min"
        :max="max"
        :step="step"
        :model-modifiers="{ lazy: !dynamic }"
        v-bind="otherAttrs"
        @input="handleInput"
      />
    </AutoSpinner>
    <slot />
  </UiField>
</template>

<script setup>
import { useAttrs, computed } from 'vue'
import UiField from '@nicolaudie-group/ng-ui-kit/components/UiField/UiField.vue'
import BaseInput from '@nicolaudie-group/ng-ui-kit/components/BaseInput/BaseInput.vue'
import AutoSpinner from '@nicolaudie-group/ng-ui-kit/components/AutoSpinner/AutoSpinner.vue'

defineOptions({
  compatConfig: {
    MODE: 3,
    INSTANCE_LISTENERS: false,
    INSTANCE_ATTRS_CLASS_STYLE: false,
  },
  inheritAttrs: false,
})

defineProps({
  label: { type: String, default: undefined },
  disabled: { type: Boolean, default: undefined },
  loading: { type: Boolean, default: undefined },
  type: { type: String, default: undefined },
  placeholder: { type: String, default: undefined },
  value: { type: [String, Number, Boolean, Array, Date, Object], default: undefined },
  inputmode: { type: String, default: undefined },
  min: { type: [Number, String], default: undefined },
  max: { type: [Number, String], default: undefined },
  step: { type: [Number, String], default: undefined },
  dynamic: { type: Boolean, default: false },
  fieldProps: { type: Object, default: () => ({}) },
})

const emit = defineEmits(['input'])

const attrs = useAttrs()

const classAttr = computed(() => attrs.class)
const otherAttrs = computed(() => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- We're removing the property, we don't need it, only the ...rest
  const { class: _unusedClassAttr, ...otherAttrs } = attrs
  return otherAttrs
})

function handleInput(value) {
  emit('input', value)
}
</script>
